<div #host class="hotspot-editor relative" style="width:100%;height:100%;">
  <annotator [imageUrl]="imageUrl" [naturalSize]="false" (onReady)="onAnnotatorReady()" [shortcut]="shortcuts"
    (onAddRectangle)="onAddRect($any($event))">
  </annotator>

  <!-- Layer dos hotspots -->
  <div class="hotspot-layer" [class.readonly]="!canEdit" *ngIf="enabledAsset"
    [style.display]="enabled ? 'block' : 'none'" style="position:absolute; inset:0;">
    <div *ngFor="let h of hotspots; let i = index" class="hotspot-dot pulse" [style.left.%]="h.xPct"
      [style.top.%]="h.yPct" (pointerdown)="isVisible(h) && startDrag($event, i)"
      (mouseenter)="isVisible(h) && openCard(i)" (mouseleave)="onPopoverMouseLeave()"
      (click)="isVisible(h) && toggleLock(i)" [class.is-dot]="markerType === 'dot'"
      [class.is-dragging]="draggingIndex === i" [class.is-number]="markerType === 'number'"
      [style.display]="isVisible(h) ? 'flex' : 'none'">
      <ng-container *ngIf="markerType === 'number'">{{ i + 1 }}</ng-container>
    </div>



    <!-- POPOVER -->
    <div *ngIf="pop" class="hotspot-popover cursor-pointer" [style.left.%]="pop.xPct" [style.top.%]="pop.yPct"
      (mouseenter)="cancelPopoverClose()" (mouseleave)="onPopoverMouseLeave()"
      style="position:absolute; transform: translate(-50%, calc(-100% - 12px)); pointer-events:auto; z-index:3;">

      <div class="card surface-card border-round-2xl shadow-2 p-2 pop-card">
        <div class="flex align-items-center gap-2 w-full" style="min-width:0;">

          <!-- Área clicável: detalhes no pai -->
          <div class="flex align-items-center gap-2 flex-1 min-w-0" (click)="productClicked.emit(pop.data)">
            <div class="thumb-56">
              <img [src]="pop.data.thumbnail" alt="" class="border-round w-full h-full" style="object-fit:cover;">
            </div>

            <div class="flex flex-column flex-1 min-w-0">
              <div class="title-ellipsis text-left font-medium line-height-2">
                {{ pop.data.name }}
              </div>

              <small class="text-600 mt-1 s-s-l-price">
                <span *ngIf="hasDiscount(pop.data)" class="line-through mr-2">
                  {{ pop.data.compare_at_price | currency:'BRL':'symbol':'1.2-2' }}
                </span>
                <span class="font-bold">
                  {{ pop.data.price | currency:'BRL':'symbol':'1.2-2' }}
                </span>
              </small>
            </div>
          </div>

          <!-- Botão "+" abre a sidebar interna -->
          <button type="button" class="p-button p-button-text p-button-rounded p-1"
            (click)="openShopForCurrent(); $event.stopPropagation()" title="Ver opções">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- POPOVER -->



  </div>
</div>


<!-- SIDEBAR INTERNA: Nesta Imagem / Produto Atual -->
<p-sidebar [(visible)]="shopVisible" [modal]="true" (onHide)="onShopHide()" position="bottom"
  class="ss-g-custom-sidebar-width ss-l-pSidebarChat ss-l-sideBarBottom ss-l-sideBarBottom2 ss-l-productsSidebar z-9 p-0 w-full s-s-l-SidebarHotSpots force-height-80"
  [style]="{
    width: '100%',
    height: '75%'
  }">

  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <h5 class="font-bold text-left m-0 w-full">Nesta imagem</h5>
    </div>
  </ng-template>

  <div class="flex flex-column gap-2" style="overflow:auto;height: 100%;">
    <div *ngFor="let p of shopProducts; let idx = index" class="mb-2">

      <!-- Enquanto carrega: SKELETON -->
      <ng-container *ngIf="p.loading && !p.loaded; else productContent">
        <div class="card mb-2 border-round-lg p-2 flex flex-column" style="position: relative;">
          <div class="flex align-items-center gap-2 w-full" style="min-width:0;">
            <div class="relative" style="width:56px;height:56px;">
              <p-skeleton width="56px" height="56px" styleClass="border-round"></p-skeleton>
            </div>

            <div class="flex flex-column flex-1 min-w-0">
              <p-skeleton width="70%" height="14px"></p-skeleton>
              <p-skeleton width="40%" height="12px" styleClass="mt-2"></p-skeleton>
            </div>
          </div>

          <!-- Skeleton dos atributos -->
          <div class="mt-3 flex flex-column gap-2">
            <p-skeleton width="100%" height="32px"></p-skeleton>
          </div>
        </div>
      </ng-container>

      <!-- Conteúdo real -->
      <ng-template #productContent>
        <div class="card mb-2 border-round-lg p-2 flex flex-column" style="position: relative;">

          <div class="flex align-items-center gap-2 w-full" style="min-width:0;">

            <div class="relative" style="width:56px;height:56px;">
              <img [src]="p.thumbnail" alt="" class="border-round w-full h-full" style="object-fit:cover;">

              <!-- ✅ Checkbox de seleção (topo-esquerda) -->
              <p-checkbox [(ngModel)]="shopSelection[p.sku ?? p.id]" [binary]="true" class="absolute"
                [ngStyle]="{ top: '-6px', left: '-6px' }">
              </p-checkbox>
            </div>

            <div class="flex flex-column flex-1 min-w-0 text-left">
              <div class="font-medium line-height-2 text-overflow-ellipsis white-space-nowrap overflow-hidden">
                {{ p.name }}
              </div>

              <small class="text-600 mt-1">
                <span *ngIf="hasDiscount(p)" class="line-through mr-2">
                  {{ p.compare_at_price | currency:'BRL':'symbol':'1.2-2' }}
                </span>
                <span class="font-bold">
                  {{ p.price | currency:'BRL':'symbol':'1.2-2' }}
                </span>
              </small>
            </div>
          </div>

          <!-- Atributos -->
          <!-- Atributos -->
          <div *ngIf="p.attributes?.length" class="attr-scroll w-full mt-2 flex flex-column gap-2">
            <div *ngFor="let attr of p.attributes" class="attr-item">
              <p-dropdown class="attr-dropdown text-left" [options]="attr.options" [placeholder]="attr.name"
                [style]="{ width: '100%' }" appendTo="body" [(ngModel)]="p.selectedAttributes[attr.name]"
                (onChange)="onAttrChange(p, attr.name, $event.value)">
              </p-dropdown>
            </div>
          </div>

          <!-- 🔴 Mensagem de erro se faltar atributo / variante -->
          <small *ngIf="attrErrors[p.sku ?? p.id]" class="p-error mt-1 block text-left">
            {{ attrErrors[p.sku ?? p.id] }}
          </small>


        </div>
      </ng-template>


    </div>
  </div>


  <ng-template pTemplate="footer">
    <button pButton type="button" class="w-full" icon="pi pi-shopping-bag" [disabled]="selectedShopCount === 0"
      (click)="addSelectedToCart()" [label]="'Adicionar (' + selectedShopCount + ')'">
    </button>
  </ng-template>
</p-sidebar>